// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/936f8de84445f99b46c5.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"111532098e6c998dd8be","191":"a9e8e42156d696b30b81","192":"f208e98dc638f7baa1e6"}[chunkId] + ".chunk.js";
};